export const getConfig = () => {
  const runtime = window?.SITE_CONFIG?.runtime;

  if (runtime) {
    return {
      backendUrl: runtime.backend_url,
      signalrUrl: runtime.signalr_url,
      tlfId: runtime.tlf_id,
      clientIp: runtime.clientip,
      recaptchaKey: runtime.recaptcha_public_key,
      partner: runtime.partner,
      showRngLogo: runtime.show_rng_logo,
      gliCertUrl: runtime.gli_cert_url,
      languageImageryPath: runtime.language_imagery_path,
      gaTag: runtime.ga_tag,
      requireLocation: runtime.require_location,
      geoBlockStage: runtime.geo_block_stage || 'SiteLoad',
      isOffline: runtime.is_offline,
      isSocialBot: runtime.is_social_bot
    };
  }

  // Production: Server injects these as global variables
  if (typeof window.tlf_backend_url !== 'undefined') {
    return {
      backendUrl: window.tlf_backend_url,
      signalrUrl: window.signalr_url,
      tlfId: window.TLF_ID,
      clientIp: window.clientip,
      recaptchaKey: window.ReCaptcha_Public_Key,
      partner: window.Partner,
      showRngLogo: window.ShowRNGLogo,
      gliCertUrl: window.GLICertUrl,
      languageImageryPath: window.LanguageImageryPath,
      gaTag: window.gA_Tag,
      requireLocation: window.require_location,
      geoBlockStage: window.geo_block_stage || 'SiteLoad',
      isOffline: window.is_offline,
      isSocialBot: window.SocialBot
    };
  }

  // Development: Use static variables from index.html
  return {
    backendUrl: window.tlf_backend_url || "https://api.dev.tlffs.ca/api/v1",
    signalrUrl: window.signalr_url || "https://api.dev.tlffs.ca/signalr",
    tlfId: window.TLF_ID || "b0b05de8-f07e-48dc-a191-0aabf2041d50",
    clientIp: window.clientip || "",
    recaptchaKey: window.ReCaptcha_Public_Key || "",
    partner: window.Partner || {},
    showRngLogo: window.ShowRNGLogo !== undefined ? window.ShowRNGLogo : true,
    gliCertUrl: window.GLICertUrl || "",
    languageImageryPath: window.LanguageImageryPath || "",
    gaTag: window.gA_Tag || "",
    requireLocation: window.require_location !== undefined ? window.require_location : false,
    geoBlockStage: window.geo_block_stage || 'SiteLoad',
    isOffline: window.is_offline !== undefined ? window.is_offline : false,
    isSocialBot: window.SocialBot !== undefined ? window.SocialBot : false
  };
};
